/** Javascript escape attribute strings. How is this not part of the lib?.
 * https://stackoverflow.com/a/30970751
 */
function escHtml(plainString) {
  return plainString.replace(/["'&<]/g, (c) => `&#${c.charCodeAt(0)};`);
}

function escJavaScript(plainString) {
  return plainString.replace(/["'\\<]/g, (c) => `\\${c === '<' ? '074' : c}`);
}

module.exports = {
  escHtml,
  escJavaScript,
};
